import { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';
import { useBackgroundScrollLock } from 'react-easyrocket';
import { useDrawer } from 'src/hooks/useDrawer';
import { HeaderInner } from 'src/components/Header/HeaderInner';
import { Header } from 'src/components/Header/Header';
import { Footer } from 'src/components/Footer';
import { FullScreenContainer } from 'src/components/FullScreenContainer';
import { AsideInner } from 'src/components/Layouts/Layout/components/AsideInner';
import '../styles.css';
import { TournamentAlert } from 'src/modules/localTournamentNotification';

const Layout: FC = () => {
  const { isLeftDrawerOpen } = useDrawer();
  // раскомментировать, когда попросят добавить модальное окно об уведомлении локального турнира
  // useOpenNewLocalTournamentModal();

  return (
    <FullScreenContainer>
      <Header
        additionalClassName={classNames('z-[600] flex flex-col', isLeftDrawerOpen && 'blured')}>
        <TournamentAlert />
        <HeaderInner />
      </Header>
      <WithDesktopSidebar>
        <div
          className={classNames(
            'w-full flex flex-col justify-start items-center',
            location.pathname.includes('pwa-instruction') && 'pwaBg'
          )}>
          <Outlet />
          {/* <HalloweenGameBanner /> */}
          <Footer />
        </div>
      </WithDesktopSidebar>
      <div className="fixed w-[240px] bottom-10 right-10"></div>
    </FullScreenContainer>
  );
};

function WithDesktopSidebar({ children }: PropsWithChildren) {
  const { isLeftDrawerOpen, closeDrawer } = useDrawer();

  useBackgroundScrollLock(isLeftDrawerOpen, [isLeftDrawerOpen]);

  return (
    <>
      <aside
        className={twMerge(
          'gf:w-full w-270 bg-bg_sidebar aside-inner fixed bottom-0 h-full z-[700] flex flex-col justify-start items-center',
          isLeftDrawerOpen
            ? 'left-[0px] ease-in-out duration-300'
            : ' ease-in-out duration-300 left-[-270px]'
        )}>
        <AsideInner />
      </aside>
      <main
        className={classNames('w-full h-full ease-in-out duration-300 flex justify-center')}
        style={{
          filter: `${isLeftDrawerOpen ? ' blur(5px) brightness(50%)' : 'none'}`
        }}>
        {children}
      </main>
      {isLeftDrawerOpen && (
        <div className="fixed top-0 left-0 w-full h-full z-[600]" onClick={closeDrawer} />
      )}
    </>
  );
}

// eslint-disable-next-line no-restricted-exports
export default Layout;
